import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcTrace = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "20.75 10.75 38.5 35.5",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(4,0) scale(3)",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M 6,4 L 6,12 C 10,16 14,16 18,12 L 18,4",
			stroke: "white",
			strokeWidth: 2.5,
			fill: "none"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M 6,4 L 6,12 C 10,16 14,16 18,12 L 18,4",
			stroke: "#00aa00",
			fill: "none"
		})]
	})
});
export default SvgIcTrace;
